module.exports = __webpack_public_path__ + "img/icon_2_36.a29e7d61.png";